import { withInstall } from '@antdv/utils';
import ASlider from './src/Slider';

export const Slider = withInstall(ASlider);

export default Slider;

export * from './src/interface';
export * from './src/props';
